import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('UserImpersonated', UserImpersonatedData);

    UserImpersonatedData.$inject = [];

    /* @ngInject */
    function UserImpersonatedData() {
        UserImpersonated.prototype = {
            build: build,
            getActorPatronime: getActorPatronime,
        };

        function UserImpersonated(UserImpersonatedData) {
            this.build(UserImpersonatedData);
        }

        return UserImpersonated;

        /////////////////////

        function build(userImpersonatedData) {
            this.userFromLogin = userImpersonatedData.userFromLogin || null;
            this.userFromLastName = userImpersonatedData.userFromLastName || null;
            this.userFromFirstName = userImpersonatedData.userFromFirstName || null;
            this.userActorLastName = userImpersonatedData.userActorLastName || null;
            this.userActorFirstName = userImpersonatedData.userActorFirstName || null;
            this.impersonatedCreatDate = userImpersonatedData.impersonatedCreatDate || null;
        }

        function getActorPatronime() {
            return this.userActorFirstName + ' ' + this.userActorLastName;
        }
    }
})();
